export default "__VITE_ASSET__fee2c004__"